// extracted by mini-css-extract-plugin
export default {"item":"CategoryItem_item__4qNDE"};